import moment from "moment";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Notifications = ({
  fileNumber,
  fileID,
  notificationID,
  notificationText,
  addedBy,
  userId,
  dateAdded,
  removeNote,
  index,
  t,
}) => {
  const [showAll, setShowAll] = useState(false);
  return (
    <div key={index} className="border-b pb-4">
      <div className="flex justify-between items-center">
        <span className="font-semibold">
          {t("orderNo")} :{" "}
          <Link
            to={`/ordersummary/${fileNumber}#notes`}
            onClick={() => {
              if (window.location.href.includes("#notes")) {
                const notesHistorySection =
                  document.getElementById("notes-history");
                if (notesHistorySection)
                  notesHistorySection.scrollIntoView({ behavior: "smooth" });
              }
              removeNote(
                fileID,
                notificationID,
                notificationText,
                addedBy,
                userId
              );
              // notesHistoryRef.current.scrollIntoView({
              //   behavior: "smooth",
              //   block: "start",
              // });
            }}
          >
            <span className="underline">{fileNumber}</span>
          </Link>
        </span>
        <button
          className="text-gray-400 hover:text-gray-60 mr-3"
          onClick={() =>
            removeNote(
              fileID,
              notificationID,
              notificationText,
              addedBy,
              userId
            )
          }
        >
          &times;
        </button>
      </div>
      <p className="text-sm text-gray-700 mt-2">
        {showAll ? (
          <span dangerouslySetInnerHTML={{ __html: notificationText }}></span>
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: notificationText.substr(0, 70),
            }}
          ></span>
        )}
      </p>
      {notificationText && notificationText.length > 67 && (
        <div className="flex flex-row">
          <button
            onClick={() => setShowAll((prev) => !prev)}
            id="show-more"
            type="button"
            className="flex link self-center"
          >
            {showAll ? t("showLess") : t("showMore")}
          </button>
          {showAll ? (
            <svg
              className="ml-3 self-center show-arrow"
              width="20"
              height="20"
              fill="none"
            >
              <path
                d="M4.076 11.691 10 6.307l5.923 5.384"
                stroke="#526D7D"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              className="ml-3 self-center hide-arrow"
              width="20"
              height="20"
              fill="none"
            >
              <path
                d="M4.076 6.309 10 11.693l5.923-5.384"
                stroke="#526D7D"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      )}
      <p className="text-xs text-gray-500 mt-2">
        {t("added")} : {moment(dateAdded).format("MMM D, YYYY hh:mm A")}
      </p>
      <br></br>
    </div>
  );
};

export default Notifications;
